<div *ngIf="user?.status !== possibleStatuses.ok" class="crm-field-info-edit">
  <mat-icon class="crm-field-info-edit__icon">error_outline</mat-icon>
  <div>{{possibleMessages[user?.status]}}</div>
</div>
